<template>
  <div class="form-score">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
      style="margin-bottom: 20px"
    />
    <gkFormCustomGroup
      class="form-group"
      :class="typeId === 100600 ? '' : 'type-nps'"
      :field="data.id + '-' + options.key + '-' + data.type"
      :rule="isValidity ? rules : []"
      :validity="isValidity"
      v-model="value"
    >
      <!-- 评分 -->
      <div class="star" v-if="typeId === 100600">
        <Rate ref="star" @on-change="changeStar" :count="options.max_score" v-model="starValue"/>
      </div>
      <!-- NPS值 -->
      <div class="nps" v-else>
        <i ref="score-num" v-if="showScore" :style="{left: scoreLeft + 'px'}" class="score-num">
          {{isMobile ? value + '分' : value}}</i>
        <Rate ref="nps" :count="options.max_score + 1" @on-change="changeNPS" v-model="starValue"/>
        <span class="min-tips">{{options.min_tips}}</span>
        <span class="max-tips">{{options.max_tips}}</span>
      </div>
    </gkFormCustomGroup>
  </div>

</template>
<script>
import {mapState} from 'vuex'
import VueTypes from 'vue-types'

import FormTitle from '@/components/FormTitle'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'

export default {
  name: 'textare-input',
  props: {
    data: VueTypes.object,
    answer: VueTypes.object
  },
  components: {
    FormTitle,
    gkFormCustomGroup
  },
  data () {
    return {
      value: '',
      showScore: false,
      fullLength: 0,
      starValue: 0
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
    typeId () {
      return this.data.type
    },
    options () {
      return this.data.details.options[0]
    },
    rules () {
      let rule = []

      if (this.data.is_must_answer) {
        rule.push({'required': '请打分'})
      }

      return rule
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    },
    scoreLeft () {
      let full = this.$refs.nps.$el.querySelectorAll('.ivu-rate-star-full')
      let lastFullLeft = full[this.fullLength - 1].offsetLeft

      return lastFullLeft
    }
  },
  created () {
  },
  methods: {
    changeStar (val) {
      this.value = val
      this.showScore = true
      let full = this.$refs.star.$el.querySelectorAll('.ivu-rate-star-full')
      this.fullLength = full.length
    },
    changeNPS (val) {
      this.value = val - 1
      this.showScore = true
      let full = this.$refs.nps.$el.querySelectorAll('.ivu-rate-star-full')
      this.fullLength = full.length
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/_common";

.form-score {
  & .type-nps {
    padding-bottom: 20px;
  }

  & ::v-deep .ivu-rate-star-zero,
  & ::v-deep .ivu-rate-star-full {
    width: 24px; height: 24px;
    cursor: pointer;

    & span {
      display: none;
    }

    &::before {
      content: '';
    }
  }

  & .star {
    line-height: 1;

    & ::v-deep .ivu-rate {
      height: 24px;
    }
    & ::v-deep .ivu-rate-star {
      margin-right: 12px;
      background-image: url('../../../assets/img/form/star-nocheck.png');
      background-size: cover;
      background-position: center;
    }

    & ::v-deep .ivu-rate-star-full {
      background-image: url('../../../assets/img/form/star-check.png');
    }
  }

  & .nps {
    position: relative;

    & .score-num {
      position: absolute;
      top: 0;
      width: 57px;
      text-align: center;
      color: #fff; font-weight: bold; font-size: 14px; line-height: 23px;
      z-index: 3;
    }

    & ::v-deep .ivu-rate {
      position: relative;
      display: flex;
      justify-content: space-between;

      & .ivu-rate-star {
        width: 78px; height: 23px;
        margin-right: 5px;
        background-color: #E9EBEE;

        &:first-of-type {
          border-radius: 4px 0 0 4px;
        }

        &:last-of-type {
          margin-right: 0;
          border-radius: 0 4px 4px 0;
        }

        &:hover {
          transform: scale(1);
        }
      }

      & .ivu-rate-star-full {
        background-color: $blue;
      }
    }

    & .min-tips,
    & .max-tips {
      position: absolute; bottom: -20px;
      color: #4a4a4a;
      @include lineFont(14, 400);
    }

    & .min-tips {
      left: 0;
    }

    & .max-tips {
      right: 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .form-score {
    & ::v-deep .ivu-rate-star-zero,
    & ::v-deep .ivu-rate-star-full {
      width: 20px; height: 20px;
    }

    & .form-group {
      display: inline-block;
      width: 100%;

      &.type-nps {
        padding-bottom: 20px;
      }
    }

    & .star {
      & ::v-deep .ivu-rate {
        width: 100%;
      }

      & ::v-deep .ivu-rate-star {
        margin-right: calc((100vw - 40px - 24px * 10) / 10);
      }
    }

    & .nps {

      & .score-num {
        left: 50% !important; top: auto; bottom: -24px;
        margin-left: -39px;
        color: #333;
      }
      & ::v-deep .ivu-rate {
        width: 100%;
      }
      & ::v-deep .ivu-rate .ivu-rate-star {
        width: 8%;
        margin-right: 0;
      }
    }
  }
}
</style>
